import Vue from 'vue';
import shortKey from 'vue-shortkey'

Vue.use(shortKey)
console.log('shortkeys active')